/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateReservationRequest,
  GetFutureReservations200ResponseInner,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  GetRangeAvailability200ResponseValueInner,
  GetReservationCancellation200Response,
  GetReservationWarranty200Response,
  GetScripts200Response,
  UpdateReservationStatusRequest,
} from '../models/index';
import {
    CreateReservationRequestFromJSON,
    CreateReservationRequestToJSON,
    GetFutureReservations200ResponseInnerFromJSON,
    GetFutureReservations200ResponseInnerToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    GetRangeAvailability200ResponseValueInnerFromJSON,
    GetRangeAvailability200ResponseValueInnerToJSON,
    GetReservationCancellation200ResponseFromJSON,
    GetReservationCancellation200ResponseToJSON,
    GetReservationWarranty200ResponseFromJSON,
    GetReservationWarranty200ResponseToJSON,
    GetScripts200ResponseFromJSON,
    GetScripts200ResponseToJSON,
    UpdateReservationStatusRequestFromJSON,
    UpdateReservationStatusRequestToJSON,
} from '../models/index';

export interface AutoassignTableRequest {
    diners: number;
    dateTime: string;
    zone?: string;
}

export interface CancelReservationRequest {
    reservationId: string;
}

export interface CreateReservationOperationRequest {
    createReservationRequest: CreateReservationRequest;
}

export interface GetDayReservationsRequest {
    date: string;
}

export interface GetFutureReservationsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface GetRangeAvailabilityRequest {
    startDate: string;
    endDate: string;
    partySize: number;
    ignoreReservationId?: string;
}

export interface NewChargeBookingRequest {
    reservationId: string;
}

export interface RefundBookingRequest {
    reservationId: string;
}

export interface UpdateReservationRequest {
    reservationId: string;
    createReservationRequest: CreateReservationRequest;
}

export interface UpdateReservationStatusOperationRequest {
    reservationId: string;
    updateReservationStatusRequest: UpdateReservationStatusRequest;
}

export interface UpdateScriptsRequest {
    getScripts200Response?: GetScripts200Response;
}

export interface UpsertReservationCancellationRequest {
    getReservationCancellation200Response: GetReservationCancellation200Response;
}

export interface UpsertReservationWarrantyRequest {
    getReservationWarranty200Response: GetReservationWarranty200Response;
}

/**
 * 
 */
export class ReservationsApi extends runtime.BaseAPI {

    /**
     */
    async autoassignTableRaw(requestParameters: AutoassignTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['diners'] == null) {
            throw new runtime.RequiredError(
                'diners',
                'Required parameter "diners" was null or undefined when calling autoassignTable().'
            );
        }

        if (requestParameters['dateTime'] == null) {
            throw new runtime.RequiredError(
                'dateTime',
                'Required parameter "dateTime" was null or undefined when calling autoassignTable().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['diners'] != null) {
            queryParameters['diners'] = requestParameters['diners'];
        }

        if (requestParameters['dateTime'] != null) {
            queryParameters['dateTime'] = requestParameters['dateTime'];
        }

        if (requestParameters['zone'] != null) {
            queryParameters['zone'] = requestParameters['zone'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/autoassign`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async autoassignTable(requestParameters: AutoassignTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.autoassignTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cancelReservationRaw(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling cancelReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelReservation(requestParameters: CancelReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createReservationRaw(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling createReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createReservation(requestParameters: CreateReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDayReservationsRaw(requestParameters: GetDayReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFutureReservations200ResponseInner>>> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayReservations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFutureReservations200ResponseInnerFromJSON));
    }

    /**
     */
    async getDayReservations(requestParameters: GetDayReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFutureReservations200ResponseInner>> {
        const response = await this.getDayReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFutureReservationsRaw(requestParameters: GetFutureReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFutureReservations200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/future`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFutureReservations200ResponseInnerFromJSON));
    }

    /**
     */
    async getFutureReservations(requestParameters: GetFutureReservationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFutureReservations200ResponseInner>> {
        const response = await this.getFutureReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRangeAvailabilityRaw(requestParameters: GetRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetRangeAvailability200ResponseValueInner>; }>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getRangeAvailability().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getRangeAvailability().'
            );
        }

        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getRangeAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/range`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getRangeAvailability(requestParameters: GetRangeAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetRangeAvailability200ResponseValueInner>; }> {
        const response = await this.getRangeAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationCancellationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationCancellation200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/policies/cancellation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationCancellation200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationCancellation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationCancellation200Response> {
        const response = await this.getReservationCancellationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationWarrantyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationWarranty200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/policies/warranties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationWarranty200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationWarranty(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationWarranty200Response> {
        const response = await this.getReservationWarrantyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getScriptsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScripts200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/scripts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScripts200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScripts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScripts200Response> {
        const response = await this.getScriptsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async newChargeBookingRaw(requestParameters: NewChargeBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling newChargeBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/policies/payments/{reservationId}/charge`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async newChargeBooking(requestParameters: NewChargeBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.newChargeBookingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async refundBookingRaw(requestParameters: RefundBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling refundBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/reservations/policies/payments/{reservationId}/refund`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async refundBooking(requestParameters: RefundBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.refundBookingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateReservationRaw(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservation().'
            );
        }

        if (requestParameters['createReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'createReservationRequest',
                'Required parameter "createReservationRequest" was null or undefined when calling updateReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations/{reservationId}`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReservationRequestToJSON(requestParameters['createReservationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservation(requestParameters: UpdateReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateReservationStatusRaw(requestParameters: UpdateReservationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reservationId'] == null) {
            throw new runtime.RequiredError(
                'reservationId',
                'Required parameter "reservationId" was null or undefined when calling updateReservationStatus().'
            );
        }

        if (requestParameters['updateReservationStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReservationStatusRequest',
                'Required parameter "updateReservationStatusRequest" was null or undefined when calling updateReservationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations/{reservationId}/status`.replace(`{${"reservationId"}}`, encodeURIComponent(String(requestParameters['reservationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReservationStatusRequestToJSON(requestParameters['updateReservationStatusRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReservationStatus(requestParameters: UpdateReservationStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReservationStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateScriptsRaw(requestParameters: UpdateScriptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/scripts/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetScripts200ResponseToJSON(requestParameters['getScripts200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateScripts(requestParameters: UpdateScriptsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScriptsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationCancellationRaw(requestParameters: UpsertReservationCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationCancellation200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationCancellation200Response',
                'Required parameter "getReservationCancellation200Response" was null or undefined when calling upsertReservationCancellation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations/policies/cancellation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationCancellation200ResponseToJSON(requestParameters['getReservationCancellation200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationCancellation(requestParameters: UpsertReservationCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationCancellationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationWarrantyRaw(requestParameters: UpsertReservationWarrantyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationWarranty200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationWarranty200Response',
                'Required parameter "getReservationWarranty200Response" was null or undefined when calling upsertReservationWarranty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/reservations/policies/warranties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationWarranty200ResponseToJSON(requestParameters['getReservationWarranty200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationWarranty(requestParameters: UpsertReservationWarrantyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationWarrantyRaw(requestParameters, initOverrides);
    }

}
